"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDefaultCartesianGrid = void 0;
var Colors_1 = require("@CommonFrontend/Styles/Colors");
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
function GetDefaultCartesianGrid() {
    return react_1.default.createElement(recharts_1.CartesianGrid, { horizontal: true, vertical: false, strokeDasharray: "3", stroke: Colors_1.ColorPalette.Slate, opacity: 0.25 });
}
exports.GetDefaultCartesianGrid = GetDefaultCartesianGrid;
